import { Music } from 'lucide-react';
import { useLang } from '../i18n';

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
  else el.scrollIntoView({ behavior: 'smooth' });
};

const HeaderNav = () => {
  const { lang, t, setLang } = useLang();
  return (
    <header
      data-testid="header-nav"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#070e12]/70 border-b border-[#d4af37]/15"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="header-logo-btn"
          onClick={() => scrollTo('#hero')}
          className="flex items-center gap-3 group"
        >
          <span className="w-9 h-9 rounded-full border border-[#d4af37]/50 flex items-center justify-center bg-[#0c171c] group-hover:bg-[#d4af37]/10 transition-colors duration-300">
            <Music size={15} className="text-[#e6c687]" strokeWidth={1.5} />
          </span>
          <span className="text-left leading-tight">
            <span className="block font-display text-lg tracking-wide text-[#f3e5ab]">
              Trinity Masterclass
            </span>
            <span className="block font-mono-alt text-[9px] tracking-[0.3em] uppercase text-[#a3b1b6]">
              Amici per la Musica APS
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {[
            ['#sfoglia', t('nav.browse'), 'header-nav-sfoglia'],
            ['#iscrizione', t('nav.enroll'), 'header-nav-iscrizione'],
            ['#sedi', t('nav.venues'), 'header-nav-sedi'],
            ['#contatti', t('nav.contacts'), 'header-nav-contatti'],
          ].map(([href, label, id]) => (
            <button
              key={id}
              data-testid={id}
              onClick={() => scrollTo(href)}
              className="font-mono-alt text-[11px] tracking-[0.25em] uppercase text-[#a3b1b6] hover:text-[#f3e5ab] transition-colors duration-300"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            data-testid="lang-switcher"
            className="flex items-center rounded-full border border-[#d4af37]/40 bg-[#0c171c]/60 overflow-hidden"
          >
            {['it', 'en'].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}-btn`}
                onClick={() => setLang(l)}
                aria-pressed={lang === l}
                className={`px-3.5 py-1.5 font-mono-alt text-[10px] tracking-[0.2em] uppercase transition-colors duration-300 ${
                  lang === l
                    ? 'bg-[#d4af37] text-[#070e12] font-medium'
                    : 'text-[#a3b1b6] hover:text-[#f3e5ab]'
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <span
            data-testid="header-year-badge"
            className="hidden sm:inline-block font-mono-alt text-[10px] tracking-[0.2em] uppercase text-[#e6c687] border border-[#d4af37]/40 rounded-full px-4 py-1.5 bg-[#0c171c]/60"
          >
            A.A. 2026–2027
          </span>
        </div>
      </div>
    </header>
  );
};

export default HeaderNav;
